import type { TokenBase, TokenSearchResponse, TokensResponse } from './0x/token-registry.types';

// Join the search results from multiple pages into a single array of unique tokens
export const joinSearchResults = (
  searchResultsPaginated: (TokensResponse | TokenSearchResponse)[],
): TokenBase[] => {
  const map = new Map<string, TokenBase>();

  searchResultsPaginated.forEach((page) => {
    if ('data' in page && page.data) {
      page.data.forEach((token) => {
        map.set(`${token.chainId}-${token.address}`, token);
      });
    }
  });

  return Array.from(map.values());
};
export const makeImageProxyUrl = (chainId: number, address: string, fullSize = false) => {
  const url = `https://matcha-image-proxy.api.0x.org/images/${chainId}/${address}`;
  if (fullSize) {
    return `${url}/original`;
  }
  return url;
};
